module.exports = __webpack_public_path__ + "media/images/top/img_interview_224kin224-b68eab05a3ebd1697665463f2cfd7096.jpg";